// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MAI3","colBig":"styles_colBig__3nuds","colSmall":"styles_colSmall___MGrP","shopifyNameWrapper":"styles_shopifyNameWrapper__2kHbg"};